export const version = "Producción 1.0.15";
export const enableErrorLog = false;
export const enableLogin = false;
export const rolesConAcceso = ["0", "1", "2", "3", "4", "5"];
export const adminKey = "al3d3sm4";

//--------------SISTEMA PAPELERA--------------

export const urlBase = "https://api-arab.app-kaizen.com.ar/public/api/"; //development
// export const urlBase = "https://remitos.arab.com.ar/api/public/api/"; //production

// NOMBREPC -- URLAFIP
const { nombre } = JSON.parse(localStorage.getItem("nombrePc")) ?? "";
export const urlAFIP = `https://${nombre}/KaizenFEAPI/`;

//--------------SISTEMA PAPELERA--------------
